
export const adaptProductResponse = (iterator) => {
  console.log('iterator',iterator)
  return {
    limit_stock: iterator?.limit_stock.raw,
    id_pharol: iterator?.id_pharol.raw,
    original_image: iterator?.original_image.raw,
    price_per_quantity: iterator?.price_per_quantity.raw,
    _meta: iterator?._meta.raw,
    id: iterator?.id.raw,
    master_category: iterator?.master_category.raw,
    brand: iterator?.brand.raw,
    meta_descriptions: iterator?.meta_descriptions.raw,
    slug: iterator?.slug.raw,
    image: iterator?.image.raw,
    meta_title: iterator?.meta_title.raw,
    principe_active: iterator?.principe_active.raw,
    editable_name: iterator?.editable_name.raw,
    laboratory: iterator?.laboratory.raw,
    shape_pharmacy: iterator?.shape_pharmacy.raw,
    name: iterator?.name.raw,
    clear_concentration: iterator?.clear_concentration.raw,
    prescription_type: iterator?.prescription_type.raw,
    indication: iterator?.indication.raw,
    sub_category: iterator?.sub_category.raw,
    ean13: iterator?.ean13.raw,
    meta_keywords: iterator?.meta_keywords.raw,
    interface: iterator?.interface.raw,
    storage_conditions: iterator?.storage_conditions.raw,
    car: iterator?.car.raw,
    validate_recipe: iterator?.validate_recipe.raw,
    sort_stock: iterator?.sort_stock.raw,
    image_320: iterator?.image_320.raw,
    image_120: iterator?.image_120.raw,
    bioequivalent: iterator?.bioequivalent.raw,
    cooled: iterator?.cooled.raw,
    concentration: iterator?.concentration.raw,
    on_demand: iterator?.on_demand.raw,
    referrer: iterator?.referrer?.raw,
    interface_pbm: iterator?.interface_pbm.raw,
    promotions: iterator?.promotions.raw,
    pregnancy_and_lactation: iterator?.pregnancy_and_lactation.raw,
    liquid: iterator?.liquid.raw,
    quantity_per_container: iterator?.quantity_per_container.raw,
    category: iterator?.category.raw,
    code_isp: iterator?.code_isp.raw,
    cenabast: iterator?.cenabast.raw,
    price: iterator?.price?.raw,
    promotion_price: iterator?.promotion_price?.raw,
  };
};